"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const cross_svg_1 = __importDefault(require("../../assets/icons/cross.svg"));
function CrossButton(props) {
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({}, props, { "data-e2e": 'CrossButton_Container', children: (0, jsx_runtime_1.jsx)(CrossIcon, { "data-e2e": 'CrossButton_CrossIcon' }) })));
}
exports.CrossButton = CrossButton;
const Container = styled_components_1.default.button `
  padding: 0;
  margin: 0;
  border: none;
  background: none;

  height: 25px;
  width: 25px;

  flex-shrink: 0;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  color: ${({ theme }) => theme.designSystem.textSecondary};
`;
const CrossIcon = (0, styled_components_1.default)(cross_svg_1.default) `
  height: 100%;
  width: 100%;
`;
